import { render, staticRenderFns } from "./SearchBarItemPharmacy_site.vue?vue&type=template&id=b60a6c18"
import script from "./SearchBarItemPharmacy_site.vue?vue&type=script&lang=js"
export * from "./SearchBarItemPharmacy_site.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports